import type { FC } from "react";

import {
  TPreviewCardProps,
} from "@/ui/components/data-display/Card/Card.config";

import { BaseCard } from "./BaseCard";
import { PreviewCardIntroduction } from "./PreviewCard/PreviewCardIntroduction";


export const PreviewCard: FC<TPreviewCardProps> = (
  {
    image,
    title,
    tags,
    ...props
  },
) => (
  <BaseCard
    data-component="PreviewCard"
    image={{ fit: "cover", ...image }}
    ratio="4:3"
    tags={tags}
    tagVariant={"secondary"}
    className="rounded-sys-lg"
    {...props}
  >
    <PreviewCardIntroduction title={title} />
  </BaseCard>
);

PreviewCard.displayName = "PreviewCard";
